<div class="repeat-section">
  @for (field of field.fieldGroup; track field.id; let index = $index) {
    <div class="repeat-section-item">
      <div class="collapse-trigger">
        <i
          class="clickable icon"
          [class.mynaui-chevron-right]="field.props.collapsed"
          [class.mynaui-chevron-down]="!field.props.collapsed"
          (click)="toggleCollapse(index)"></i>
      </div>

      <formly-field [field]="field" class="repeat-section-item-wrapper" [class.collapsed]="field.props.collapsed" />

      @if (!props.hideButtons) {
        <div class="repeat-section-action" [class.collapsed]="field.props.collapsed">
          @if (!formControl.at(index)?.value?.is_edit) {
            <cap-button
              styleClass="default primary round btn-sm icon-only"
              icon="mynaui-pencil"
              [disabled]="addDisabled"
              (onClick)="edit(index, field)" />

            <cap-button
              styleClass="default primary round btn-sm icon-only"
              icon="mynaui-trash"
              [pTooltip]="removeDisabledTooltip"
              tooltipStyleClass="neqto-tooltip"
              [tooltipDisabled]="!(field | hasChildren: triggerCheckValue)"
              [disabled]="addDisabled || (field | hasChildren: triggerCheckValue)"
              (onClick)="removeField(index, field)" />
          } @else {
            <cap-button
              styleClass="default secondary round btn-sm icon-only"
              icon="mynaui-x"
              (onClick)="cancel(index)" />

            <cap-button
              styleClass="default secondary round btn-sm icon-only"
              icon="mynaui-check"
              (onClick)="save(index, field)" />
          }
        </div>
      }
    </div>
  } @empty {
    @if (props.isRoot) {
      <div class="repeat-empty">
        <p>{{ props.emptyText }}</p>
      </div>
    }
  }
</div>

@if (
  !props.isRoot &&
  !props.hideButtons &&
  !addDisabled &&
  (field | addChildAllowed: field?.options : field?.props.is_edit)
) {
  <div class="repeat-section-add-child">
    <cap-button
      styleClass="default primary round btn-sm icon-only"
      icon="mynaui-plus"
      [disabled]="addDisabled"
      (onClick)="add()" />
  </div>
}

@if (props.isRoot && !props.hideButtons) {
  @if (!props.max || field.fieldGroup.length < props.max) {
    <div class="repeat-section-add">
      <cap-button
        class="add"
        styleClass="primary"
        icon="mynaui-plus"
        [disabled]="addDisabled"
        [label]="'button.add' | translate"
        (onClick)="add()" />
    </div>
  }
}

<ng-template #removeDisabledTooltip>
  <div>
    {{ 'application_action.parameters.remove-disabled.label' | translate }}
  </div>
</ng-template>
